import { render, staticRenderFns } from "./PopupSwitchProgram.vue?vue&type=template&id=ae375570"
import script from "./PopupSwitchProgram.vue?vue&type=script&lang=js"
export * from "./PopupSwitchProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports